import { useEffect } from 'react';

import { assignmentsResetStatus, assignmentWindowHide, showAlert } from 'core/store/modules/common/actions';
import { STATUS } from 'core/store';

export default ({ dispatch, editAssignment, statusSet }: any) => {
  useEffect(() => {
    if (statusSet !== STATUS.SUCCESS) {
      return;
    }

    const message =
      editAssignment.updated !== editAssignment.created
        ? 'The assignment was updated'
        : 'The assignment was added';

    dispatch(showAlert(message, { variant: 'success' }));
    dispatch(assignmentWindowHide());
    dispatch(assignmentsResetStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusSet]);
};
